export default __webpack_public_path__ + "static/carpass_green~UYGFVSuw-68f6b44e3f90b721df624fc38fb7b528.png";